



















# Lib autocomplete https://github.com/paliari/v-autocomplete
item = require './company_item.vue'
helpers = require '../../../helpers.coffee'
on_clickaway = require('vue-clickaway')

view_model = {
  mixins: [ on_clickaway.mixin ]
  props: ['external_id']
  data : ->
    show: false
    current_company: Session.current_company
    current_user: Session.current_user
    company: null
    companies: []
    show_no_result_found_message: false
    item_company: item
    attrs: {
      placeholder: "Buscar empresa"
    }

  methods:
    selectCategory: (category) ->
      @category_selected = category
      @show_categories = false
      @searchTemplates("") if @category_selected

    hideCategories: ->
      @show_categories = false

    toggleCategories: ->
      @show_categories = !@show_categories

    setFocus: ->
      jQuery('#'+@id+'.v-autocomplete .v-autocomplete-input').focus()

    onClickaway: ->
      @$emit 'hide'

    getLabel: (company) ->
      company?.name

    searchCompanies: (text) ->
      params = {q: { name_cont: text }, per: 10 }
      params = {q: { name_cont: text, users_with_same_account: @current_user.email }, per: 10 } if @current_user.hasMoreAccounts()

      @company_resources.index @searchSuccess, @unknownError, params: params
    
    getInitialCompanies: ->
      params = { per: 10 }
      params = { q: { users_with_same_account: @current_user.email }, per: 10 } if @current_user.hasMoreAccounts()
      
      @company_resources.index @searchSuccess, @unknownError, params: params

    searchSuccess: (resources) ->
      @companies = resources.companies
      @show_no_result_found_message = resources.companies.length == 0

    selectedCompany: (company) ->
      @$emit "selected-company", company
      @getInitialCompanies()
      setTimeout((=> @company = ""), 500)

  computed:
    id: ->
      "company_autocomplete_"+@external_id
    
  mounted: ->
    @getInitialCompanies()
    @setFocus()

  created: ->
    @company_resources = new CompaniesResource @current_company.id
}
exports.default = helpers.vue_include(view_model, helpers.form)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/shared/autocomplete/companies.vue